import React, { useState, useEffect, memo, PropsWithChildren } from 'react'

import AppHeader from 'modules/App/AppHeader'
import AppFooter from 'modules/App/AppFooter'

import { AppLayout, AppContent } from './styled'

export default memo(
  ({ children }: PropsWithChildren<Record<string, unknown>>) => {

    const [isHeaderSticky, setIsHeaderSticky] = useState<boolean>(false)

    useEffect(() => {
      const handleScroll = () => {
        const currentScrollY = window.scrollY
        if (currentScrollY > 108) {
          setIsHeaderSticky(true)
        } else {
          setIsHeaderSticky(false)
        }
      }

      window.addEventListener('scroll', handleScroll, { passive: true })
    }, [])

    return (
      <AppLayout>
        <AppHeader isStiky={isHeaderSticky} />
        <AppContent>{children}</AppContent>
        <AppFooter />
      </AppLayout>
    )
  }
)
